import { InviteCode, CodeLayout } from 'src/app/code/index';

function CodeJoin() {
  return <InviteCode />;
}

CodeJoin.Layout = CodeLayout;

export default CodeJoin;
